import { IExportPlugin, PluginType } from '@/version-types';
import { ContextMenuPlugin } from './context-menu';
import { ContextMenuPluginDependency } from './dependency';
import ShortcutMenuPlugin from './shortcut-plugin';
import contextMenuPluginState from './states/context-menu-state';
import ContextMenu from './views/context-menu';

const exportPlugin: IExportPlugin = {
    type: PluginType.SYSTEM,
    sort: 3,
    name: 'context-menu',
    render() {
        return <ContextMenu />;
    },
    createInstance({ identity }) {
        return [
            { key: 'ContextMenuPlugin', value: new ContextMenuPlugin(identity) },
            { key: 'ContextMenuPluginDependency', value: new ContextMenuPluginDependency(identity) },
        ];
    },
    createState() {
        return [contextMenuPluginState];
    },
    dependencies() {
        return [{ plugin: ShortcutMenuPlugin }];
    },
};

export default exportPlugin;
